import { Box, Stack, Typography } from '@mui/joy';
import { cardSx, CoinAmount } from './GCoinUI';
import { RaceBadge, RankBadge, visibleLanes } from './GCoinBadges';
import { laneName, weekLabel } from './GCoinRace';

export function GCoinAchievements({ data }) {
    const wins = ['photographer', 'administrator'].filter(lane => Number(data.wins?.[lane]) > 0);
    const currentLanes = data.role === 'admin' ? ['administrator']
        : data.role === 'admin_photographer' ? ['photographer', 'administrator'] : ['photographer'];
    const monthLanes = visibleLanes(data).filter(lane => currentLanes.includes(lane) || data.positions?.[lane]?.month);
    return <Stack spacing={1.5} sx={{ mt: 2 }}>
        <Stack direction="row" useFlexGap spacing={1} sx={{ flexWrap: 'wrap' }}>
            {wins.length ? wins.map(lane => <RaceBadge key={lane} lane={lane}>{lane === 'photographer' ? 'ЛФН' : 'ЛАН'} · {data.wins[lane]}</RaceBadge>)
                : <Typography level="body-sm">Первая победа ещё впереди.</Typography>}
        </Stack>
        <Box data-testid="profile-month-summary" sx={{ p: 1.5, borderRadius: 12, bgcolor: 'var(--joy-palette-background-level2)', border: '1px solid var(--joy-palette-divider)' }}>
            <Typography level="body-xs" sx={{ mb: 1 }}>Гонка месяца · текущее место</Typography>
            <Stack spacing={1}>{monthLanes.map(lane => {
                const place = data.positions?.[lane]?.month;
                return <Stack key={lane} direction="row" useFlexGap spacing={0.75} alignItems="center" sx={{ flexWrap: 'wrap' }}>
                    <RaceBadge period="month" lane={lane}>{lane === 'photographer' ? 'ЛФМ' : 'ЛАМ'}</RaceBadge>
                    <RankBadge rank={place?.rank} />
                    {place ? <><Typography level="body-sm">{place.rank} место</Typography><CoinAmount value={place.score} sx={{ fontSize: 13 }} /></>
                        : <Typography level="body-sm">Очков пока нет</Typography>}
                </Stack>;
            })}</Stack>
        </Box>
    </Stack>;
}

export function GCoinPositions({ data }) {
    const lanes = visibleLanes(data);
    return <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: lanes.length > 1 ? '1fr 1fr' : '1fr' }, gap: 2 }}>
        {lanes.map(lane => <Box key={lane} sx={{ ...cardSx, minWidth: 0 }}>
            <Typography sx={{ fontWeight: 800, mb: 2 }}>{laneName(lane)}</Typography>
            <Stack spacing={2}>{['week', 'month', 'all'].map(period => {
                const value = data.positions?.[lane]?.[period];
                return <Box key={period}>
                    <RaceBadge period={period} lane={lane} />
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.75 }}>
                        <RankBadge rank={value?.rank} />
                        {value ? <CoinAmount value={value.score} /> : <Typography level="body-sm">Нет заработанных очков</Typography>}
                    </Stack>
                </Box>;
            })}</Stack>
        </Box>)}
    </Box>;
}

export function GCoinWins({ data }) {
    return <Box sx={cardSx}>
        <Typography sx={{ fontWeight: 800, mb: 2 }}>Последние победы</Typography>
        {!data.recent_wins?.length && <Typography level="body-sm">Первая победа ещё впереди.</Typography>}
        <Stack spacing={1.5}>{data.recent_wins?.map(row => <Box key={row.week + row.lane} sx={{ p: 1.5, borderRadius: 10, bgcolor: 'rgba(197,111,250,.06)' }}>
            <RaceBadge lane={row.lane}>{row.lane === 'photographer' ? 'ЛФН' : 'ЛАН'}</RaceBadge>
            <Typography level="body-sm" sx={{ mt: 0.5 }}>Неделя с {weekLabel(row.week)}</Typography>
            <Typography level="body-sm"><CoinAmount value={row.score} /> · приз <CoinAmount value={row.prize} /></Typography>
        </Box>)}</Stack>
        <Typography level="body-xs" sx={{ mt: 2 }}>Показаны последние 30 побед. Счётчики включают всю историю.</Typography>
    </Box>;
}
